//import _ from 'lodash';

import * as constants from './MainModeRanking.constants';
import * as services from './MainModeRanking.service';

//export const rankTypeMap = {
//  attendance: 1,
//  learningpoint: 2,
//  excise: 3,
//  excisecollection: 4,
//  percentaccuracy: 5,
//};

//const ivtRankTypeMap = _.invert(rankTypeMap);

const state = {
  rankingList: [],
  isRankingLoading: false,

  rankingDetail: {},
  isRequest: false,
};

const mutations = {
  [constants.GET_RANKING_LIST_SUCCESS](state, rankingList) {
    state.rankingList = rankingList;
  },

  [constants.GET_RANKING_DETAIL_SUCCESS](state, rankingDetail) {
    if (null !== rankingDetail && undefined !== rankingDetail) {
      state.rankingDetail = rankingDetail;
    }
  },

  [constants.SET_RANKING_LOADING](state, isRankingLoading) {
    state.isRankingLoading = isRankingLoading;
  },

  [constants.SET_IS_REQUEST_STATUS](state, status) {
    state.isRequest = status;
  },
};

const actions = {
  async getRankingList({ commit }, payload) {
    commit(constants.SET_RANKING_LOADING, true);
    const res = await services.getRankingList(payload);
    if (res.data.data) {
      commit(constants.GET_RANKING_LIST_SUCCESS, res.data.data);
    }
    commit(constants.SET_RANKING_LOADING, false);
  },

  async getRankingDetail({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.getRankingDetail(payload);
    if (200 === res.data.status) {
      commit(constants.GET_RANKING_DETAIL_SUCCESS, res.data.data);
    }
    commit(constants.SET_IS_REQUEST_STATUS, false);
  },
};

const getters = {
  //rankingInfo: (state) =>
  //  _.fromPairs(_.map(state.rankingList, (rank) => [ivtRankTypeMap[rank.rankingType], rank])),
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
